{
  "static-content-download-app": {
    "buttons": {},
    "text": {
      "title": "Stáhnout aplikaci Beauty Booking",
      "description": "Náš software je navržen tak, aby vám usnadnil život. Tak proč čekat? Stáhněte si naši aplikaci ještě dnes a začněte žít organizovaněji a bez stresu!"
    }
  }
}
